export const FilterIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
      <path
        d="M20.6 0.599976H0.599976L8.59998 10.06V16.6L12.6 18.6V10.06L20.6 0.599976Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
